import styled from 'styled-components'

export const StatusHeader = styled.div`
  margin-bottom: 36px;
`
